export const messages = {
    "wr-dashboard.search.input.hint": "검색",
    "wr-dashboard.search.label.breadcrumb": "검색 결과",
    "wr-dashboard.search.message.empty": "검색과 일치하는 항목이 없습니다",
    "wr-dashboard.side-bar.selected.title:plural": "{count}개 항목 선택됨 | {count}개 항목 선택됨",
    "wr-dashboard.side-bar.backup-type.disk": "디스크",
    "wr-dashboard.side-bar.backup-type.file": "파일",
    "wr-dashboard.side-bar.backup-type.notarized": "공증된 파일과 폴더",
    "wr-dashboard.side-bar.backup-type.exchange": "애플리케이션 - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "애플리케이션 - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "애플리케이션 - 시스템 상태",
    "wr-dashboard.side-bar.backup-type.application": "응용 프로그램",
    "wr-dashboard.backups-table.column.name": "이름",
    "wr-dashboard.backups-table.column.size": "크기",
    "wr-dashboard.backups-table.column.version": "마지막 버전",
    "wr-dashboard.backups-table.action.delete": "삭제",
    "wr-dashboard.backups-table.message.no-backups": "클라우드에 아직 백업이 없습니다",
    "wr-dashboard.backups-sidebar.label.size": "크기",
    "wr-dashboard.backups-sidebar.label.type": "유형",
    "wr-dashboard.backups-sidebar.label.version": "마지막 버전",
    "wr-dashboard.backups-sidebar.label.created": "생성됨",
    "wr-dashboard.backups-sidebar.label.machine": "머신",
    "wr-dashboard.backups-sidebar.label.owner": "소유자",
    "wr-dashboard.content-table.column.name": "이름",
    "wr-dashboard.content-table.column.versions": "버전",
    "wr-dashboard.content-table.column.volumes": "볼륨",
    "wr-dashboard.content-table.column.path": "경로",
    "wr-dashboard.content-table.column.size": "크기",
    "wr-dashboard.content-table.column.version": "마지막 버전",
    "wr-dashboard.content-table.action.notary-verify": "확인",
    "wr-dashboard.content-table.action.notary-get-crt": "인증서 가져오기",
    "wr-dashboard.content-table.action.asign": "서명을 위해 전송",
    "wr-dashboard.content-table.action.versions": "버전",
    "wr-dashboard.content-table.action.restore": "다운로드",
    "wr-dashboard.content-table.label.size": "크기",
    "wr-dashboard.content-table.label.created": "생성됨",
    "wr-dashboard.content-table.label.modified": "수정",
    "wr-dashboard.content-table.message.empty-folder": "이 폴더가 비어 있습니다",
    "wr-dashboard.password-dialog-box.title.backup": "암호화된 백업",
    "wr-dashboard.password-dialog-box.title.archive": "암호화된 아카이브",
    "wr-dashboard.password-dialog-box.message.backup": "백업 {displayName}에 액세스하기 위한 비밀번호를 지정하십시오",
    "wr-dashboard.password-dialog-box.message.archive": "아카이브 {displayName}에 액세스하기 위한 비밀번호를 지정하십시오",
    "wr-dashboard.password-dialog-box.hint.password": "암호",
    "wr-dashboard.password-dialog-box.message.invalid-password": "비밀번호가 잘못되었습니다",
    "wr-dashboard.form.button.open": "열기",
    "wr-dashboard.form.button.close": "닫기",
    "wr-dashboard.form.button.cancel": "취소",
    "wr-dashboard.form.button.continue": "계속",
    "wr-dashboard.form.button.proceed": "진행",
    "wr-dashboard.form.button.delete": "삭제",
    "wr-dashboard.form.button.done": "완료",
    "wr-dashboard.form.button.retry": "재시도",
    "wr-dashboard.notary.verify.view.status.downloading": "다운로드 중...",
    "wr-dashboard.notary.verify.view.status.validating": "유효성 검사 중...",
    "wr-dashboard.notary.verify.view.status.pending": "보류 중인 인증서...",
    "wr-dashboard.notary.verify.view.status.fail": "인증서 불일치...",
    "wr-dashboard.notary.verify.view.button.get-crt": "인증서 가져오기",
    "wr-dashboard.notary.verify.view.file-info.name": "이름",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "서명인",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "백업된 날짜:",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "공증된 날짜",
    "wr-dashboard.notary.verify.view.button.cancel": "취소",
    "wr-dashboard.notary.verify.view.button.done": "완료",
    "wr-dashboard.notary.warning.unsupported.browser.version": "지원되지 않는 브라우저 버전",
    "wr-dashboard.versions-dialog-box.title": "{fileName} 버전",
    "wr-dashboard.asign-dialog-box.title": "서명을 위해 전송",
    "wr-dashboard.asign-dialog-box.message": "파일 버전이 공유되었지만 파일 링크가 없으면 아무도 검토할 수 없습니다. ASign을 계속 진행해 서명인을 추가하고 링크를 공유하십시오.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "상세정보 표시",
    "wr-dashboard.page-not-found.title": "페이지를 찾을 수 없음",
    "wr-dashboard.page-not-found.message.main": "찾고 있는 페이지가 없습니다.",
    "wr-dashboard.page-not-found.message.description": "링크가 오래되었거나 주소를 잘못 입력했을 수 있습니다.",
    "wr-dashboard.page-not-found.message.error": "오류 코드: 404",
    "wr-dashboard.server-error.title": "서버가 작동하지 않습니다",
    "wr-dashboard.server-error.message": "현재 서버를 사용할 수 없습니다. 나중에 다시 시도하십시오.",
    "wr-dashboard.server-error.message.error": "오류 코드: 500",
    "wr-dashboard.account-menu.action.sign-out": "로그아웃",
    "wr-dashboard.breadcrumb.item.machines": "머신",
    "wr-dashboard.breadcrumb.item.failed-backups": "실패한 백업",
    "wr-dashboard.machines-table.column.name": "이름",
    "wr-dashboard.machines-table.column.size": "크기",
    "wr-dashboard.machines-table.message.no-machines": "클라우드에 아직 머신이 없습니다",
    "wr-dashboard.incomplete-backups.message.status:plural": "스토리지의 {size}을(를) 차지하는 실패하거나 완료하지 못한 백업이 {count}개 있습니다 | 스토리지의 {size}을(를) 차지하는 실패하거나 완료하지 못한 백업이 {count}개 있습니다",
    "wr-dashboard.incomplete-backups.button.view": "백업 보기",
    "wr-dashboard.incomplete-backups.button.delete": "백업 삭제",
    "wr-dashboard.machines-table.message.space-used:plural": "총 백업 사용 {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "아카이브 삭제",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "불완전한 아카이브 삭제",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "불완전한 아카이브 모두 삭제",
    "wr-dashboard.delete-archive.message": "선택한 아카이브를 모든 위치에서 영구 삭제하시겠습니까? 모든 데이터가 삭제되며 복구할 수 없습니다.",
    "wr-dashboard.delete-archive.deletion-warning-message": "보호 콘솔의 해당 워크로드와 변경 사항을 처리하는 에이전트가 온라인 상태가 아닌 경우에는 이 Web Restore 콘솔에서 적용하는 변경 사항이 워크로드에 표시되지 않을 수도 있습니다.",
    "wr-dashboard.delete-archive.locked-error-message": "데이터 일관성을 위해 아카이브가 잠겼습니다. 아카이브가 포함된 모든 작업(예: 찾아보기, 복원, 백업)을 종료하고 다시 시도하십시오.",
    "wr-dashboard.certificate-pending-dialog-box.title": "인증서 보류 중",
    "wr-dashboard.certificate-pending-dialog-box.message": "몇 분 후에 다시 시도하십시오.",
    "wr-dashboard.form.button.ok": "확인"
};
